<div class="ui-g-12" *ngIf="showTabs">
    <div class="card card-w-title">
        <div>
            <p-tabView [(activeIndex)]="selectedTab" (onChange)="this.onTabChange($event)">
                <p-tabPanel [header]="this.isSupport ? 'Upload Medical Documents' : 'Uploaded Documents'" leftIcon="pi pi-upload" id="profile-tab"
                    [disabled]="id_form.show_form">
                    <div class="ui-g-12">
                        <p-button (click)="showBasicDialog()" icon="pi pi-question" label="Info"
                            styleClass="p-button-lg">
                        </p-button>
                    </div>
                    <p-dialog header="Upload Information" [(visible)]="displayBasic" [style]="{width: '50vw'}"
                        [baseZIndex]="10000">
                        <p style="text-align: center;">Max file size should be less than 4.8MB and upto 3 files are
                            allowed. Only images and pdf files are accepted.</p>
                        <ng-template pTemplate="footer">
                            <p-button icon="pi pi-check" (click)="displayBasic=false" label="Yes"
                                styleClass="p-button-text"></p-button>
                            <p-button icon="pi pi-times" (click)="displayBasic=false" label="No"></p-button>
                        </ng-template>
                    </p-dialog>
                    <p-confirmDialog key="confirm-delete-document" header="Delete Document" acceptLabel="Yes"
                        rejectLabel="No" [(visible)]="confirmDialogVisible"></p-confirmDialog>
                    <div class="form-group card" *ngFor="let d of Document_data">

                        <div class="input-group">
                            <div class="ui-g-12">
                                <label for="fileName" style="word-break: break-word">{{d.name | titlecase}} :</label>
                            </div>
                            <div class="row">
                                <form>
                                    <span class="input-group-btn">
                                        <div class="ui-g-12 ui-g">
                                            <div *ngIf="d.data.length==0">
                                                <p-fileUpload #uploadfileform [auto]="true" [showCancelButton]="false"
                                                    [accept]="acceptedAttachmentTypes" mode="advanced"
                                                    styleClass="p-fileUpload-label-fix" [maxFileSize]="5033165"
                                                    [multiple]="false" fileLimit="10" [disabled]="!this.isSupport"
                                                    (uploadHandler)="uploadFiles($event.files,d.id,uploadfileform)"
                                                    customUpload="true"></p-fileUpload>
                                                <div class="col-md-1"></div>
                                                <div class="ui-g-12">
                                                    <app-error-messages [api_result]="apiResult">
                                                    </app-error-messages>
                                                </div>
                                            </div>
                                            <div *ngIf="d.data.length==1">
                                                <p-fileUpload #uploadfileform [auto]="true" [showCancelButton]="false"
                                                    [accept]="acceptedAttachmentTypes" mode="advanced"
                                                    styleClass="p-fileUpload-label-fix" [maxFileSize]="5033165"
                                                    [multiple]="false" fileLimit="10" [disabled]="!this.isSupport"
                                                    (uploadHandler)="uploadFiles($event.files,d.id,uploadfileform)"
                                                    customUpload="true"></p-fileUpload>
                                                <div class="col-md-1"></div>
                                                <div class="ui-g-12">
                                                    <app-error-messages [api_result]="apiResult">
                                                    </app-error-messages>
                                                </div>
                                            </div>
                                            <div *ngIf="d.data.length==2">
                                                <p-fileUpload #uploadfileform [auto]="true" [showCancelButton]="false"
                                                    [accept]="acceptedAttachmentTypes" mode="advanced"
                                                    styleClass="p-fileUpload-label-fix" [maxFileSize]="5033165"
                                                    [multiple]="false" fileLimit="10" [disabled]="!this.isSupport"
                                                    (uploadHandler)="uploadFiles($event.files,d.id,uploadfileform)"
                                                    customUpload="true"></p-fileUpload>
                                                <div class="col-md-1"></div>
                                                <div class="ui-g-12">
                                                    <app-error-messages [api_result]="apiResult">
                                                    </app-error-messages>
                                                </div>
                                            </div>
                                            <div *ngIf="d.data.length==3">
                                                <p-fileUpload #uploadfileform [auto]="true" [showCancelButton]="false"
                                                    [accept]="acceptedAttachmentTypes" mode="advanced"
                                                    styleClass="p-fileUpload-label-fix" [maxFileSize]="5033165"
                                                    [multiple]="false" [disabled]="true" fileLimit="10"
                                                    [disabled]="!this.isSupport"
                                                    (uploadHandler)="uploadFiles($event.files,d.id,uploadfileform)"
                                                    customUpload="true"></p-fileUpload>
                                                <div class="col-md-1"></div>
                                                <div class="ui-g-12">
                                                    <app-error-messages [api_result]="apiResult">
                                                    </app-error-messages>
                                                </div>
                                            </div>
                                        </div>

                                    </span>

                                    <p-table [value]="d.data" class="ui-g-12">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>
                                                    File Name
                                                </th>
                                                <th>Size</th>
                                                <th><i class="pi pi-cog" style="font-size: 1rem;"></i></th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-file>
                                            <tr>
                                                <td class="ellipsis-overflow-text"><a [href]="file.document_link"
                                                        target="_blank" rel="noopener noreferrer"
                                                        style="word-break: break-word">{{file.document_name}}</a></td>
                                                <td>{{file.formattedDocumentSize}}
                                                </td>
                                                <td><span *ngIf="this.isSupport">
                                                        <i class="pi pi-trash" style="font-size: 1rem;cursor: pointer;"
                                                            (click)="confirmDocumentDelete($event,file.document_name,file.file_id,d.id,file.document_key)"></i>
                                                    </span>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </form>
                            </div>
                        </div>
                    </div>




                    <div class="input-group" style="padding-top: 3%;">

                        <label *ngIf="this.isSupport" class="ui-md-4">Other :</label>
                        <input *ngIf="this.isSupport" class="ui-lg-3" type="text" [pKeyFilter]="name_input" pInputText
                            [(ngModel)]="new_doc_name" [value]="new_doc_name"
                            style="margin-bottom:10px;margin-right:5px;" />
                        <span *ngIf="this.isSupport" class="pi pi-plus-circle"
                            style="margin-bottom:10px;margin-right:5px; font-size: 2em;cursor: pointer;position:absolute"
                            (click)="addDoc()"> </span>
                    </div>


                    <br>
                    <br>
                </p-tabPanel>
            </p-tabView>
        </div>
    </div>
</div>